import * as React from "react";
import {PrimaryModels} from "../../_definitions/styleteq";
import Style from "../../_data/models/Style";
import MyStylesGalleryImageComponent from "../../style/components/MyStylesGalleryImageComponent";
import User from "../../_data/models/User";
import SearchTrendingUserComponent from "./SearchTrendingUserComponent";
import Shop from "../../_data/models/Shop";
import Special from "../../_data/models/Special";
import SearchResult from "../../_data/models/SearchResult";
import SearchTrendingShopComponent from "./SearchTrendingShopComponent";
import SearchTrendingSpecialComponent from "./SearchTrendingSpecialComponent";
import SearchResultItemComponent from "./SearchResultItemComponent";

interface Props {
    result: SearchResult;
    model: PrimaryModels;
    forTrending?: boolean;
    viewItem: () => void;
    dependencies: {
        shop?: Shop;
        user?: User;
    };
}

const SearchResultComponent = (props: Props) => {
    const {result, model, forTrending, viewItem, dependencies} = props;

    if (forTrending) {
        if (model instanceof Style)
            return <MyStylesGalleryImageComponent item={model as Style}/>
        else if (model instanceof User)
            return <SearchTrendingUserComponent user={model as User} viewItem={viewItem} result={result}/>
        else if (model instanceof Shop)
            return <SearchTrendingShopComponent shop={model as Shop} result={result} viewItem={viewItem}/>
        else if (model instanceof Special)
            return <SearchTrendingSpecialComponent special={model as Special} result={result} viewItem={viewItem}/>
    } else
        return <SearchResultItemComponent result={result} model={model} viewItem={viewItem} dependencies={dependencies}/>
};
export default SearchResultComponent;


// WEBPACK FOOTER //
// ./app/client/search/components/SearchResultComponent.tsx